<template>
  <div v-if="issue.volume">

    <div class="hidden-md-up">
      <sidebar-current-issue></sidebar-current-issue>
      <sidebar-signup-button></sidebar-signup-button>
    </div>

    <div class="row issue-number hidden-sm-down">
      <div class="col-md-8"><h2>Volume {{issue.volume}}, Number {{issue.issue}}</h2></div>
      <div class="col-md-4">Pages: {{issue.pages.start}} - {{issue.pages.end}}</div>
    </div>
    <div id="issueAnchors" class="left-column hidden-sm-down">
      <img width="170" class="mb-2" :src="issue.optimized_urls.small" />
      <div>
        <a class="link" v-for="link in issue.rubricLinks" :key="link.url" :href="link.url" :class="{'active': currentSection === link.id}">
          {{link.text}}<i class="icon icon-color-arrow-right"></i>
        </a>
      </div>
    </div>
    <div class="right-column">
      <full-issue v-if="topArticle.ids" v-bind:issue="topArticle"></full-issue>

      <title-block v-for="group in issue.rubricLinks" :key="group.id" :title="group.text" :id="group.id" color-theme="primary-color">
        <div>
          <condensed-issue v-for="(article, index) in issue.articles" :key="article.ids.pii" v-bind:issue="article"
                           v-if="article.article_type.name == group.text"
                           :smallMode="index > 0 && article.article_type.name === issue.articles[index-1].article_type.name ? true : false" :hideType="true">
          </condensed-issue>
        </div>
      </title-block>

      <div class="hidden-md-up">
        <title-block title="Impact Factor / Index / Archive:">
          <div class="sidebar-block-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
        </title-block>
        <sidebar-sponsorship></sidebar-sponsorship>
      </div>

    </div>
  </div>
</template>

<script>
  import SidebarSponsorship from '@/components/main-layout/sidebar/SidebarSponsorshipComponent'
  import SidebarCurrentIssue from '@/components/main-layout/sidebar/SidebarCurrentIssueComponent'
  import SidebarSignupButton from '@/components/main-layout/sidebar/SidebarSignUpButtonComponent'
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import FullIssue from '@/components/shared/FullIssueComponent'
  import CondensedIssue from '@/components/shared/CondensedIssueComponent'
  import SectionsBeyondOncology from '@/components/home/SectionsBeyondOncologyComponent'
  import SpecialCollectionArchives from '@/components/home/SpecialCollectionArchivesComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'

  export default {
    components: {
      SidebarSponsorship,
      SidebarCurrentIssue,
      SidebarSignupButton,
      TitleBlock,
      FullIssue,
      CondensedIssue,
      SectionsBeyondOncology,
      SpecialCollectionArchives
    },
    name: 'issue-detail',
    mixins: [ UtilityMixin ],
    data () {
      return {
        siteName: process.env.SITE_NAME,
        issue: {},
        topArticle: {},
        currentSection: false
      }
    },
    created () {
      this.$http.get(this.$store.state.dataUrlArticle).then(function (response) {
        var topArticle = response.body
        // TODO: This part should be removed after services implementation - optimized_urls is missed in article.json example
        for (var i = 0; i < topArticle.files.figures.length; i++) {
          topArticle.files.figures[i].optimized_urls = {}
          topArticle.files.figures[i].optimized_urls['small'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/' + topArticle.files.figures[i].optimized_file
          topArticle.files.figures[i].optimized_urls['hero'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/' + topArticle.files.figures[i].optimized_file
        }
        this.topArticle = topArticle
      }, function () {
      })

      this.$http.get(this.$store.state.dataUrlIssue).then(function (response) {
        var issue = response.body
        var unique = function (arr) {
          var nArray = []
          for (var i = 0; i < arr.length; i++) {
            if (!nArray.find(function (item) { return item.text === arr[i].text })) {
              nArray.length += 1
              nArray[nArray.length - 1] = arr[i]
            }
          }
          return nArray
        }

        issue.rubricLinks = unique(
          issue.articles.map(
            function (item) {
              return {
                id: item.article_type.nlm_type,
                url: '/issue/volume/' + issue.volume + '/number/' + issue.issue + '#' + item.article_type.nlm_type,
                text: item.article_type.name
              }
            }
          )
        )
        this.issue = issue
        if (!issue.current) {
          this.$root.$emit('changeBreadCrumbs',
            [
              {
                text: 'Archived Issues',
                name: 'archivedIssues'
              }
            ]
          )
        }
      }, function () {
      })
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
      if (location.hash) {
        var self = this
        setTimeout(function () {
          var anchor = self.$el.querySelector(location.hash)
          if (anchor) {
            window.scroll(0, anchor.getBoundingClientRect().top)
          }
        }, 1000)
      }
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll () {
        if (!this.$store.state.isEnhanced) {
          let issueAnchors = document.getElementById('issueAnchors')
          let issueAnchorsParent = issueAnchors ? issueAnchors.parentElement : null
          let scrollPosition = issueAnchors ? (parseInt(issueAnchorsParent.offsetTop)) : 0
          if (!issueAnchors) {
            return false
          }

          // 200 -> Heder.height - #navWrapper.height
          // 60 -> #navWrapper.height + 10
          // 420 -> footer.height + 10
          this.scrolled = window.scrollY > (scrollPosition + 200)

          if (this.scrolled && (window.scrollY + issueAnchors.offsetHeight + 10 + 420) > (document.documentElement.scrollHeight || document.body.scrollHeight)) {
            issueAnchors.style.top = 'auto'
            issueAnchors.style.bottom = 20 + 'px'
            issueAnchors.style.position = 'absolute'
          } else if (this.scrolled) {
            issueAnchors.style.bottom = 'auto'
            issueAnchors.style.top = 60 + 'px'
            issueAnchors.style.position = 'fixed'
          } else {
            issueAnchors.style.position = 'static'
          }
        }
        this.highlightSection()
      },
      highlightSection () {
        let currentSection = null
        this.$el.querySelectorAll('.right-column section[id]').forEach(function (el) {
          if (el.getBoundingClientRect().top <= 10) {
            currentSection = el.id
          } else if (!currentSection && el.getBoundingClientRect().top < (document.documentElement.clientHeight || document.body.clientHeight)) {
            currentSection = el.id
            return false
          }
        })
        this.currentSection = currentSection
      }
    }
  }
</script>


<style lang="scss" scoped>
  .issue-number {
    line-height: 50px;
    margin: 10px 0;
    > div:last-child {
      text-align: right;
    }
  }

  [id]:before {
    display: block;
    content: "";
    height: 60px;
    margin: -60px 0 0;
  }

  @media (min-width: $breakpoint-md) {
    .right-column {
      margin-left: 200px;
    }
  }
  .left-column {
    position: relative;
    top:0;
    width: 170px;
    float: left;
  }
  .link {
    font-size: 14px;
    font-family: 'Open Sans';
    border-bottom: 1px solid #dedede;
    display: block;
    line-height: 32px;
    position: relative;
    font-weight: 100;
    .icon {
      margin-left: 10px;
    }
    &:hover {
      text-decoration: none;
    }
    &.active {
      font-weight: bold;
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// IssueDetailPage.vue?5d317278